import { CustomCssVarsFn } from '@wix/yoshi-flow-editor';

export type StylesParams = {};

export const stylesParams = {};

export default stylesParams;

export const customCssVars: CustomCssVarsFn = () => ({});
